import { Grid, P, Wrapper } from '@farewill/ui'
import { WithCopyToClipboard } from 'components/with-copy-to-clipboard'

const PlanReference = ({
  funeralPlanReference,
}: {
  funeralPlanReference?: string
}) => {
  if (!funeralPlanReference) return <></>

  return (
    <Grid.Item>
      <Wrapper margin={['M', 0, 0]}>
        <P margin={0}>
          This funeral was redeemed from a plan, reference:{' '}
          <WithCopyToClipboard value={funeralPlanReference} label="Plan ref">
            <strong>{funeralPlanReference}</strong>
          </WithCopyToClipboard>
        </P>
      </Wrapper>
    </Grid.Item>
  )
}

export default PlanReference
